
//删除对象中 undefined、null、length === 0 的key
export function deleteEmptyObject(ob) {
    for (let e in ob) {
        if (typeof(ob[e]) === 'undefined' || ob[e] === null || ob[e].length === 0) {
            delete ob[e];
        }
        else if (ob[e].constructor === Object) {
            if (Object.keys(ob[e]).length === 0) {
                delete ob[e];
            } else {
                delUndefined(ob[e]);
            }
        }
        else if (ob[e].constructor === Array) {
            ob[e].map(function (seg) {
                if (typeof(seg) === 'object') {
                    delUndefined(seg);
                }
            });
        }
    }
    return ob;
}

export function isOffline() {
  // eslint-disable-next-line no-undef
  return process.env.NODE_ENV === 'offline'
}

export function xssFilterStr(str){
  return  str.replace(/"/g,'&quot;')
  .replace(/'/g,'&apos;')
  .replace(/</g,'&lt;')
  .replace(/>/g,'&gt;')
}

export function xssFilterUrl(url){
  return decodeURIComponent(encodeURIComponent(url))
}

/**
 * 保留小数点几位数, 自动补零, 不做四舍五入
 * @param num: 数值
 * @param digit: 小数点后位数
 * @returns string
 */
 export function customToFixed(num, digit = 0) {
  if(Object.is(parseFloat(num), NaN)) {
    console.log(`传入的值：${num}不是一个数字`);
    return num
  }
  if(digit === 0) {
    return (num > 0 ? Math.floor(num) : Math.ceil(num)) + ''
  }
  num += ''
  if(num.indexOf('.') === -1) {
    return num + '.' + new Array(digit).fill(0).join('')
  } else {
    const idx = num.split('').reverse().indexOf('.')
    if(idx > digit) {
      const idx = num.indexOf('.')
      return num.slice(0, idx + digit + 1)
    } else if(idx < digit) {
      return num + new Array(digit - idx).fill(0).join('')
    } else {
      return num
    }
  }
}

// base64 编码解码
export const base64 = {
  encode (str) {
    return window.btoa(unescape(encodeURIComponent(str)))
  },
  decode (base64) {
    return decodeURIComponent(escape(window.atob(base64)))
  }
}

export const getFileName = (url) => {
  let result = url
  if (url && url.length) {
    const u = url.split('?')[0]
    result = u.split('/')[u.split('/').length - 1]
  }
  return result
}

export const isError = (value) =>{
  return value instanceof Error;
}

export async function download_rename(downloadUrl, downloadFileName ) {
  const blob = await getBlob(downloadUrl);
  saveAs(blob, downloadFileName );
}

function getBlob(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new Error(`Request failed with status ${xhr.status}`));
      }
    };
    xhr.onerror = () => {
      reject(new Error('Request failed'));
    };

    xhr.send();
  });
}

function saveAs(blob, filename) {
  const link = document.createElement('a');
  const body = document.body;

  link.href = window.URL.createObjectURL(blob);
  link.download = filename;

  // hide the link
  link.style.display = 'none';
  body.appendChild(link);

  link.click();
  body.removeChild(link);

  window.URL.revokeObjectURL(link.href);
}



// WEBPACK FOOTER //
// ./src/utils/common.js